import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { array, bool, func, object } from 'prop-types';
import { ArrowForwardIos } from '@mui/icons-material';
import cn from 'classnames';

import styles from '../styles.module.scss';

import { ANCHOR_ORIGIN, TRANSFORM_ORIGIN } from './constants';

const SelectTime = ({ timeOptions, handleChange, selectedTime, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChange = value => {
    handleChange(value);
    handleClose();
  };

  return (
    <div>
      <Button
        onClick={handleClick}
        endIcon={<ArrowForwardIos />}
        className={cn(styles.timeOptions, {
          [styles.disabledTimeOptions]: disabled
        })}
      />
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
        open={open}
        onClose={handleClose}
        className={styles.selectTimeContainer}>
        {timeOptions?.map(({ name, value }) => (
          <MenuItem
            key={name}
            onClick={() => onChange(value)}
            selected={selectedTime.value === value}
            className={cn(styles.optionLabel, {
              [styles.selectedTime]: selectedTime.value === value
            })}>
            {name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

SelectTime.propTypes = {
  handleChange: func.isRequired,
  timeOptions: array.isRequired,
  disabled: bool,
  selectedTime: object
};

export default SelectTime;
